module.exports = __webpack_public_path__ + "static/media/reply.0f571054.svg";